import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import NoDataPlaceholder from 'components/common/general/NoDataPlaceholder';

export const NoDataPlaceholderStyled = styled(NoDataPlaceholder)`
  background-color: ${colors.neutral.white};
  box-sizing: border-box;
  padding: 4rem;
  border-radius: 10px;
  border: 1px solid ${colors.neutral[300]};
`;

export const DescriptionStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-align: center;
  align-items: center;
`;
